const BASE_URL = "https://docs.qboxmail.com";

module.exports = {
  it: {
    aliasDomains_add: `${BASE_URL}/it/panel/gestione/domini-alias#aggiungere-un-dominio-alias`,
    aliasEmailAccounts_add: `${BASE_URL}/it/panel/gestione/email-alias#aggiungere-un-email-alias`,
    archive: `${BASE_URL}/it/panel/gestione/archivio`,
    archive_domain_add: `${BASE_URL}/it/panel/gestione/archivio#aggiungere-archivio-a-un-dominio`,
    archive_domain_settings: `${BASE_URL}/it/panel/gestione/archivio#impostazioni-archivio-dominio`,
    archive_emailAccount_add: `${BASE_URL}/it/panel/gestione/archivio#aggiungere-archivio-a-uno-o-piu-email-account`,
    archive_emailAccount_import: `${BASE_URL}/it/panel/gestione/archivio#importare-messaggi-di-un-email-account-in-archivio`,
    archive_emailAccount_settings: `${BASE_URL}/it/panel/gestione/archivio#impostazioni-archivio-email-account`,
    audits: `${BASE_URL}/it/panel/analisi/registro`,
    customizations: `${BASE_URL}/it/panel/gestione/personalizzazioni`,
    customizations_domains_add: `${BASE_URL}/it/panel/gestione/personalizzazioni#attivare-una-personalizzazione-per-dominio`,
    customizations_domains_edit: `${BASE_URL}/it/panel/gestione/personalizzazioni#modificare-una-personalizzazione-per-dominio`,
    customizations_general_add: `${BASE_URL}/it/panel/gestione/personalizzazioni#attivare-una-personalizzazione-generale`,
    customizations_general_edit: `${BASE_URL}/it/panel/gestione/personalizzazioni#modificare-una-personalizzazione-generale`,
    delegates: `${BASE_URL}/it/panel/ruoli/delegati`,
    delegates_add: `${BASE_URL}/it/panel/ruoli/delegati#aggiungere-un-delegato`,
    delegates_settings: `${BASE_URL}/it/panel/ruoli/delegati#impostazioni-del-delegato`,
    domains: `${BASE_URL}/it/panel/gestione/domini`,
    domains_add: `${BASE_URL}/it/panel/gestione/domini#aggiungere-un-dominio`,
    domains_settings: `${BASE_URL}/it/panel/gestione/domini#impostazioni-del-dominio`,
    emailAccount_add: `${BASE_URL}/it/panel/gestione/email-account#aggiungere-un-email-account`,
    emailAccount_settings: `${BASE_URL}/it/panel/gestione/email-account#impostazioni-dell-email-account`,
    etlive: `${BASE_URL}/it/panel/analisi/etlive`,
    imports: `${BASE_URL}/it/panel/importazioni-migrazioni/importazioni`,
    imports_add: `${BASE_URL}/it/panel/importazioni-migrazioni/importazioni#creare-un-file-csv-per-una-importazione`,
    managers: `${BASE_URL}/it/panel/ruoli/manager`,
    managers_add: `${BASE_URL}/it/panel/ruoli/manager#aggiungere-un-manager`,
    managers_settings: `${BASE_URL}/it/panel/ruoli/manager#impostazioni-del-manager`,
    migrations: `${BASE_URL}/it/panel/importazioni-migrazioni/migrazioni`,
    migrations_add: `${BASE_URL}/it/panel/importazioni-migrazioni/migrazioni#creare-un-file-csv-per-una-migrazione`,
    postmasters: `${BASE_URL}/it/panel/ruoli/postmaster`,
    teamMembers: `${BASE_URL}/it/panel/ruoli/team-member`,
    teamMembers_add: `${BASE_URL}/it/panel/ruoli/team-member#aggiungere-un-team-member`,
    teamMembers_settings: `${BASE_URL}/it/panel/ruoli/team-member#impostazioni-del-team-member`,
    user_settings: `${BASE_URL}/it/panel/come-iniziare/impostazioni-generali`,
    orders: `${BASE_URL}/it/panel/altro/ordini`,
    mtmRestores: `${BASE_URL}/it/mail-time-machine/backup`,
    // email delivery
    deliveryAccounts: `${BASE_URL}/it/email-delivery/gestione/utenze`,
    deliveryAddAccount: `${BASE_URL}/it/email-delivery/gestione/utenze#aggiungere-un-utenza`,
    deliveryAccountPlan: `${BASE_URL}/it/email-delivery/caratteristiche/piani-disponibili`,
    deliveryDomains: `${BASE_URL}/it/email-delivery/gestione/domini`,
    deliveryAddDomain: `${BASE_URL}/it/email-delivery/gestione/domini#aggiungere-un-nuovo-domin`,
    deliveryDomainsVerification: `${BASE_URL}/it/email-delivery/gestione/domini#dettagli-domini`,
    deliveryDomainsApproval: `${BASE_URL}/it/email-delivery/gestione/domini#dettagli-domini`,
    deliverySuppressionList: `${BASE_URL}/it/email-delivery/gestione/lista-di-soppressione`,
    deliveryAddSuppressionList: `${BASE_URL}/it/email-delivery/gestione/lista-di-soppressione#aggiungere-rimuovere-indi`,
    // prices
    pricesWebLabel: `${BASE_URL}/it/caratteristiche/personalizzazioni#web-label`,
    pricesPrivateLabel: `${BASE_URL}/it/caratteristiche/personalizzazioni#private-label`,
    pricesArchive: `${BASE_URL}/it/archivio/come-iniziare/intro`,
    pricesBackup: `${BASE_URL}/it/mail-time-machine/mail-time-machine`,
    pricesDailyMessages: `${BASE_URL}/it/caratteristiche/smtp-policy#pacchetti-di-invio-smtp-a`,
  },
  en: {
    aliasDomains_add: `${BASE_URL}/en/panel/management/domain-alias#add-a-domain-alias`,
    aliasEmailAccounts_add: `${BASE_URL}/en/panel/management/email-alias#add-an-email-alias`,
    archive: `${BASE_URL}/en/panel/management/archives`,
    archive_domain_add: `${BASE_URL}/en/panel/management/archives#add-archive-to-a-domain`,
    archive_domain_settings: `${BASE_URL}/en/panel/management/archives#domain-archive-settings`,
    archive_emailAccount_add: `${BASE_URL}/en/panel/management/archives#add-archive-to-one-or-more-email-accounts`,
    archive_emailAccount_import: `${BASE_URL}/en/panel/management/archives#import-messages-from-an-email-account-in-the-archive`,
    archive_emailAccount_settings: `${BASE_URL}/it/panel/gestione/archivio#impostazioni-archivio-email-account`,
    audits: `${BASE_URL}/en/panel/analysis/audits`,
    customizations: `${BASE_URL}/en/panel/management/customizations`,
    customizations_domains_add: `${BASE_URL}/en/panel/management/customizations#activate-a-customization-by-domain`,
    customizations_domains_edit: `${BASE_URL}/en/panel/management/customizations#change-a-customization-by-domain`,
    customizations_general_add: `${BASE_URL}/en/panel/management/customizations#activate-a-general-customization`,
    customizations_general_edit: `${BASE_URL}/en/panel/management/customizations#change-a-general-customization`,
    delegates: `${BASE_URL}/en/panel/roles/delegates`,
    delegates_add: `${BASE_URL}/en/panel/roles/delegates#add-a-delegate`,
    delegates_settings: `${BASE_URL}/en/panel/roles/delegates#delegate-settings`,
    domains: `${BASE_URL}/en/panel/management/domains`,
    domains_add: `${BASE_URL}/en/panel/management/domains#add-a-domain`,
    domains_settings: `${BASE_URL}/en/panel/management/domains#domain-settings`,
    emailAccount_add: `${BASE_URL}/en/panel/management/email-accounts#add-an-email-account`,
    emailAccount_settings: `${BASE_URL}/en/panel/management/email-accounts#email-account-settings`,
    etlive: `${BASE_URL}/en/panel/analysis/etlive`,
    imports: `${BASE_URL}/en/panel/imports-migrations/imports`,
    imports_add: `${BASE_URL}/en/panel/imports-migrations/imports#create-a-csv-file-for-an-import`,
    managers: `${BASE_URL}/en/panel/roles/managers`,
    managers_add: `${BASE_URL}/en/panel/roles/managers#add-a-manager`,
    managers_settings: `${BASE_URL}/en/panel/roles/managers#manager-settings`,
    migrations: `${BASE_URL}/en/panel/imports-migrations/migrations`,
    migrations_add: `${BASE_URL}/en/panel/imports-migrations/migrations#create-a-csv-file-for-a-migration`,
    postmasters: `${BASE_URL}/en/panel/roles/postmasters`,
    teamMembers: `${BASE_URL}/en/panel/roles/team-members`,
    teamMembers_add: `${BASE_URL}/en/panel/roles/team-members#adding-a-team-member`,
    teamMembers_settings: `${BASE_URL}/en/panel/roles/team-members#team-member-settings-1`,
    user_settings: `${BASE_URL}/en/panel/getting-started/settings`,
    orders: `${BASE_URL}/en/panel/other/orders`,
    mtmRestores: `${BASE_URL}/en/mail-time-machine/backup`,
    // email delivery
    deliveryAccounts: `${BASE_URL}/en/email-delivery/management/accounts`,
    deliveryAddAccount: `${BASE_URL}/en/email-delivery/management/accounts#adding-an-account`,
    deliveryAccountPlan: `${BASE_URL}/en/email-delivery/features/available-plans`,
    deliveryDomains: `${BASE_URL}/en/email-delivery/management/domains`,
    deliveryAddDomain: `${BASE_URL}/en/email-delivery/management/domains#adding-a-new-domain`,
    deliveryDomainsVerification: `${BASE_URL}/en/email-delivery/management/domains#domain-details`,
    deliveryDomainsApproval: `${BASE_URL}/en/email-delivery/management/domains#domain-details`,
    deliverySuppressionList: `${BASE_URL}/en/email-delivery/management/suppression-list`,
    deliveryAddSuppressionList: `${BASE_URL}/en/email-delivery/management/suppression-list#adding-removing-addresses`,
    //prices
    pricesWebLabel: `${BASE_URL}/en/features/customizations#web-label`,
    pricesPrivateLabel: `${BASE_URL}/en/features/customizations#private-label`,
    pricesArchive: `${BASE_URL}/en/archive/getting-started/intro`,
    pricesBackup: `${BASE_URL}/en/mail-time-machine/mail-time-machine`,
    pricesDailyMessages: `${BASE_URL}/en/features/smtp-policy#additional-smtp-send-pack`,
  },
};
